import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "@src/reducers/store";

import { SaveBluePrintModal } from "@components/organisms/modals/blueprints/save-blueprint-modal/save-blueprint-modal";

export const BlueprintSave = () => {
  const showSaveBlueprintModal = useSelector(
    (state: RootState) =>
      state.yourSlice.saveBlueprintModal.showSaveBlueprintModal,
  );

  return <>{showSaveBlueprintModal && <SaveBluePrintModal />}</>;
};
